<template>
  <!-- exhibition-activity .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>我的云店</BreadcrumbItem>
          <BreadcrumbItem>活动计划</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">活动计划</div>
        <!-- <p class="header-tool-text" style="font-weight:bold;color:#00a0e9;">重要提示：此部分活动信息将于CMEF移动端小程序与PC端同步显示，供观众查询使123用</p>  -->
        <!-- <Input
          search
          placeholder="请输入关键字"
          v-model="searchField"
          @on-search="searchPro()"
          v-if="String(showTabs) === '1'"
          style="width:230px;margin-top:20px;"
        /> -->
      </div>
      <div v-show="String(showTabs) === '1'" class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/activity/addpro')">
          <span class="htb-add">+</span>
          <span>添加活动</span>
        </div>
      </div>
    </div>
    <div class="header-tabs">
      <div style="margin:20px;background:white;min-height:700px">
        <div style="padding:50px 0 0 50px">
          <div style="display:flex">
            <div>
              <span style="width:80px;display: inline-block;text-align: right;">公司名称：</span>
              <Input disabled :value="company.name" style="width: 400px"></Input>
            </div>
            <div>
              <span style="width:160px;display: inline-block;text-align: right;">Company Name：</span>
              <Input disabled :value="company.nameEn" style="width: 400px" />
            </div>
          </div>
          <div style="display:flex;margin-top:20px">
            <div>
              <span style="width:80px;display: inline-block;text-align: right;">展馆号：</span>
              <Input disabled :value="joinInfo.exArea" style="width: 400px" />
            </div>
            <div>
              <span style="width:160px;display: inline-block;text-align: right;">展位号：</span>
              <Input disabled :value="joinInfo.exHall" style="width: 400px" />
            </div>
          </div>
          <div style="margin:20px 0;font-size:18px;font-weight:bold">
            <span>展位活动信息</span>
          </div>
          <div class="list-content-info-r">
            <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
              <template slot-scope="{ row }" slot="index">{{
                                    row.index
                            }}</template>
              <template slot-scope="{ row }" slot="name">{{
                                    row.name
                            }}</template>
              <template slot-scope="{ row }" slot="typeName">{{
                                    row.typeName
                            }}</template>
              <template slot-scope="{ row }" slot="startTime">
                {{ row.startTime | moment("YYYY/MM/DD") }}~{{ row.endTime | moment("YYYY/MM/DD") }}

              </template>
              <template slot-scope="{ row }" slot="address">{{
                                    row.address
                            }}</template>
              <template slot-scope="{ row }" slot="action">
                <span style="cursor: pointer;" @click="editRow(row)">编辑</span>
                <span style="margin:0 5px">|</span>
                <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
                  <span style="color: #f00; cursor: pointer">删除</span>
                </Poptip>
              </template>
            </Table>
            <div style="margin-top:20px">
              <Button type="primary" @click="$router.push('/exhibition/index/activity/addpro')" style="width:140px;height:35px;font-size:14px">添加展位活动</Button>
            </div>
          </div>
          <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px; text-align: center">
            <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
          </div>
          <div style="margin-top:20px;font-size:18px;font-weight:bold">
            企业联系方式
          </div>
          <div>
            <Form ref="form1" :model="companyData" :label-width="140" :rules="ruleValidate">
              <div style="display:flex;margin-top:20px">
                <FormItem label="联系人:" prop="LinkName">
                  <Input v-model="companyData.LinkName" placeholder="请输入联系人" style="width: 400px"></Input>
                </FormItem>
                <FormItem label="手机：" prop="LinkPhone">
                  <Input v-model="companyData.LinkPhone" placeholder="请输入手机" style="width: 400px"></Input>
                </FormItem>
              </div>
              <div style="display:flex;">
                <FormItem label="电话：" prop="LinkTel">
                  <Input v-model="companyData.LinkTel" placeholder="请输入电话" style="width: 400px"></Input>
                </FormItem>
                <FormItem label="传真：" prop="LinkFax">
                  <Input v-model="companyData.LinkFax" placeholder="请输入传真" style="width: 400px"></Input>
                </FormItem>
              </div>
              <div style="display:flex;">
                <FormItem label="E-mail：" prop="Email">
                  <Input v-model="companyData.Email" placeholder="请输入E-mail" style="width: 400px"></Input>
                </FormItem>
                <FormItem label="网站：">
                  <Input v-model="companyData.WebSite" placeholder="请输入网站" style="width: 400px"></Input>
                </FormItem>
              </div>
              <div style="display:flex">
                <FormItem label="地址：" prop="Address">
                  <Input v-model="companyData.Address" placeholder="请输入地址" style="width: 400px"></Input>
                </FormItem>
                <FormItem label="邮编：" prop="PostNumber">
                  <Input v-model="companyData.PostNumber" placeholder="请输入邮编" style="width: 400px"></Input>
                </FormItem>
              </div>
              <div style="display:flex;">
                <FormItem label="官方网站：">
                  <Input v-model="companyData.OfficialWebSite" placeholder="请输入官方网站" style="width: 400px"></Input>
                </FormItem>
                <FormItem label="官网微博或微信：">
                  <Input v-model="companyData.OfficialWBorWc" placeholder="请输入官网微博或微信" style="width: 400px"></Input>
                </FormItem>
              </div>

              <div style="margin-top:20px;height:80px">
                <Button type="primary" @click="update('form1')" style="width:140px;height:35px;font-size:14px">保存</Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import exhibitionActivityItem from './../../subpages/exhibition-activity-item/exhibition-activity-item.vue'
import exhibitionActivityMes from './../../subpages/exhibition-activity-mes/exhibition-activity-mes.vue'

import Contact from '@components/Contact/Contact'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'exhibition-business',
  data () {
    return {
      addBrandflag: false,
      showTabs: '1',
      searchField: '', // 搜索关键字
      form: {
        name: '',
      },
      pageSize: 50,
      pageIndex: 1,
      totalCount: 0,
      columns1: [
        {
          title: "活动序号",
          key: "index",
          align: "center",
          width: "100",
        },
        {
          title: "活动名称",
          key: "name",
          align: "center",
          width: "300",
        },
        {
          title: "活动类型",
          key: "typeName",
          align: "center",
        },
        {
          title: "活动时间",
          slot: "startTime",
          key: "authentication",
          align: "center",
        },
        {
          title: "活动地点",
          slot: "address",
          key: "authentication",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      companyData: {
        Id: '',
        LinkName: '',
        LinkPhone: '',
        LinkTel: '',
        LinkFax: '',
        Email: '',
        WebSite: '',
        Address: '',
        PostNumber: '',
        OfficialWebSite: '',
        OfficialWBorWc: '',
      },
      list: [],
      ruleValidate: {
        LinkName: [
          { required: true, message: "联系人不能为空", trigger: "blur" }
        ],
        LinkPhone: [
          { required: true, message: "手机不能为空", trigger: "blur" }
        ],
        LinkTel: [
          { required: true, message: "电话不能为空", trigger: "blur" }
        ],
        // LinkFax: [
        //   { required: true, message: "传真不能为空", trigger: "blur" }
        // ],
        Email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" }
        ],
        // Address: [
        //   { required: true, message: "地址不能为空", trigger: "blur" }
        // ],
        // PostNumber: [
        //   { required: true, message: "邮编不能为空", trigger: "blur" }
        // ],
      },
    }
  },
  components: {
    exhibitionActivityItem,
    exhibitionActivityMes,
    Contact,
  },
  created () {
    this.changeTab()
  },
  computed: {
    ...mapGetters({
      company: 'loginModule/getCompany',
      exhibition: 'loginModule/getExhibition',
      joinInfo: "loginModule/getJoinInfo",
    }),

    query () {
      return this.$route.query
    },
  },
  mounted () {
    this.init()
    this.getEnterprise()
    console.log(this.joinInfo)
  },
  methods: {
    ...mapActions({
      getActivityFiboGetByPage: "activityModuleNew/getActivityFiboGetByPage",
      delActivity: "activityModuleNew/delActivity",
      getEnterpriseContactId: "activityModuleNew/getEnterpriseContactId",
      addEnterpriseContact: "activityModuleNew/addEnterpriseContact",
      editEnterpriseContact: "activityModuleNew/editEnterpriseContact",
    }),
    async init () {
      let opt = {
        ExhibitionId: this.exhibition.id,
        compId: this.company.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      }
      let data = await this.getActivityFiboGetByPage(opt)
      data.items.map((item, index) => {
        item.index = index + 1
      })
      this.list = data.items

      this.pageSize = data.pageSize
      this.pageIndex = data.pageIndex
      this.totalCount = data.totalCount;
    },
    async getEnterprise () {
      let opt = {
        exhibitionId: this.exhibition.id,
        compId: this.company.id
      }
      let data = await this.getEnterpriseContactId(opt)
      this.companyData.Id = data.id
      this.companyData.LinkName = data.linkName
      this.companyData.LinkPhone = data.linkPhone
      this.companyData.LinkTel = data.linkTel
      this.companyData.LinkFax = data.linkFax
      this.companyData.Email = data.email
      this.companyData.WebSite = data.webSite
      this.companyData.Address = data.address
      this.companyData.PostNumber = data.postNumber
      this.companyData.OfficialWebSite = data.officialWebSite
      this.companyData.OfficialWBorWc = data.officialWBorWc
    },
    async validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async update (name) {
      let valid = await this.validForm(name);

      if (!valid) {
        this.$Message.warning();
      }
      if (!valid) return;
      if (this.companyData.Id) {
        let opt = {
          Id: this.companyData.Id,
          SetValues: {
            LinkName: this.companyData.LinkName,
            LinkPhone: this.companyData.LinkPhone,
            LinkTel: this.companyData.LinkTel,
            LinkFax: this.companyData.LinkFax,
            Email: this.companyData.Email,
            WebSite: this.companyData.WebSite,
            Address: this.companyData.Address,
            PostNumber: this.companyData.PostNumber,
            OfficialWebSite: this.companyData.OfficialWebSite,
            OfficialWBorWc: this.companyData.OfficialWBorWc,
          }
        }
        let bool = await this.editEnterpriseContact(opt);
        if (bool.successed) {
          this.$Message.success("保存成功");
        }
        this.getEnterprise()
      } else {
        this.companyData.exhibitionId = this.exhibition.id
        this.companyData.compId = this.company.id
        let bool = await this.addEnterpriseContact(this.companyData);
        if (bool.successed) {
          this.$Message.success("保存成功");
          this.getEnterprise()
        } else {
          this.$Message.error("保存失败，请重新尝试");
        }
      }

    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },
    searchPro () {
      this.$refs.exhibitionActivityItem.init()
    },
    changeTab () {
      if (this.query && this.query.type && this.query.type === 'all') {
        this.showTabs = '1'
      } else if (this.query && this.query.type && this.query.type === 'mes') {
        this.showTabs = '2'
      }
    },
    switchBrand (name) {
      if (name === '1') {
        this.$router.push(`${this.$route.path}?type=all`)
      } else if (name === '2') {
        this.$router.push(`${this.$route.path}?type=mes`)
      }
    },
    editRow (row) {
      this.$router.push(`/exhibition/index/activity/editpro?id=${row.id}`);
    },
    async delItem (item) {
      let result = await this.delActivity(item.id);
      if (result.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败");
      }
    },
  },
}
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;

  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;

    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }

    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }

    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
